export const SITE_SOURCE_FOREIGN_KEY = 'IdUsMeasureSite';

export const CLINICAL_EVAL_COMBO_SOURCE_FOREIGN_KEY = 'IdUsClinicalEvaluationCombo';

export const NEW_LINE_CHAR = '<BR>';

export const NEW_LINE_FOR_TEXT = '\n';
